module.exports = __webpack_public_path__ + "img/trains1.c8eb18d7.svg";